import { DeleteScheduleEffectiveTimeSettingRequest } from './interface/delete-schedule-effective-time-setting-request';
import { Component, Injector, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { isEmpty, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { ScheduleEffectiveTimeSettingService } from '../../service/schedule-effective-time-setting.service';
import { SaveScheduleEffectiveTimeSettingBean } from './interface/save-schedule-effective-time-setting-bean';
import { SaveScheduleEffectiveTimeSettingRequest } from './interface/save-schedule-effective-time-setting-request';
import { SearchScheduleEffectiveTimeSettingRequest } from './interface/search-schedule-effective-time-setting-request';
import { formatDate } from '@angular/common';
import { SearchScheduleEffectiveTimeSettingBean } from './interface/search-schedule-effective-time-setting-bean';
import { DropdownChangeEvent } from 'primeng/dropdown/dropdown.interface';
import { finalize } from 'rxjs';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';

@Component({
  selector: 'laas-schedule-effective-time-setting',
  templateUrl: './schedule-effective-time-setting.component.html',
  styleUrls: ['./schedule-effective-time-setting.component.scss'],
})
export class ScheduleEffectiveTimeSettingComponent
  extends SessionBaseComponent
  implements OnInit
{
  readonly viewPermissionCode = PermissionConstants.ViewScheduleEffectiveTimeSetting;
  currentLang: string = this.laasSetting.language;
  hours = Array.from({ length: 24 }, (_, i) => i);
  dates: string[] = [];
  selectedCells: boolean[][] = []; //本次選擇時動畫部分
  backUpPreSelectedCells: boolean[][] = []; //回覆上一動
  showCells: boolean[][] = []; //畫面顯示
  selectedCellsState: Map<string, boolean> = new Map(); // 記錄當前選取狀態
  startRow: number = -1;
  startCol: number = -1;
  endRow: number = -1;
  endCol: number = -1;
  columns: any[] = [];
  startTimeArray: (number | null)[][][] = [];
  endTimeArray: (number | null)[][][] = [];

  isEditable: boolean = false;
  isMouseDown: boolean = false;
  isSearchFormOpen: boolean = true;
  isLoading: boolean = false;
  isDialogOpen: boolean = false;
  isQuerySuccessful: boolean = false;
  submitted: boolean = false;

  settingHeaderOptions: any[] = [];
  searchRequest: SearchScheduleEffectiveTimeSettingRequest = {};
  searchResult: SearchScheduleEffectiveTimeSettingBean[] = [];
  saveBeans: SaveScheduleEffectiveTimeSettingBean[] = [];
  tempSaveBeans: SaveScheduleEffectiveTimeSettingBean[] = [];
  searchForm: FormGroup;
  dialogData = { startMinute: 0, endMinute: 0 };

  headerSeqNo: number = 0;
  startTime: any;
  endTime: any;
  urgentSettingScheduleName: string = '';
  showUrgentNoSetting: boolean = false;
  isUrgentSettingLoading: boolean = false;
  urgentNoPreferenceKey: string = UserPreferenceConstants.UrgentNoPreferenceKey;
  urgentNoDatas = [];
  urgentNoColumns = [
    { field: 'action', header: 'ScheduleSetting.UrgentNoSetting.Table.Action', width: 50 },
    { field: 'urgentNo', header: 'ScheduleSetting.UrgentNoSetting.Table.UrgentNo', sort: true, width: 200 },
  ];
  newUrgentNo: string = '';
  isAddingUrgentNo: boolean = false;
  

  constructor(
    private scheduleEffectiveTimeSettingService: ScheduleEffectiveTimeSettingService,
    private injector: Injector,
    private fb: FormBuilder
  ) {
    super(injector);
    this.searchForm = this.fb.group({
      scheduleName: [null, Validators.required],
      plant: [null, Validators.required],
    });

    this.columns = [
      { field: 'date', header: 'ScheduleSetting.Table.Date', width: 100 },
      {
        field: 'startTime',
        header: 'ScheduleSetting.Table.Time',
        width: 100,
      },
      {
        field: 'delete',
        header: '',
        width: 40,
      },
    ];

    this.hours.forEach((hour: number) => {
      this.columns.push({ field: hour, header: hour });
    });

  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.initOptions();
    this.initializeDates();
    this.initializeGrid();
  }

  initOptions() {
    this.scheduleEffectiveTimeSettingService
    .searchScheduleEffectiveTimeSettingHeaderOptions()
    .subscribe({
      next: (result) => {
        const set = new Set<string>();
        const distinctResult = result.filter((item: any) => {
          if (set.has(item.scheduleName)) return false;
          set.add(item.scheduleName);
          return true;
        });

        this.settingHeaderOptions = distinctResult.map((item: any) => ({
          label: item.scheduleDesc,
          value: item.scheduleName,
        }));
      },
    });

  }

  initializeDates() {
    this.dates = []; // 確保每次初始化時清空日期列表
    const today = new Date();
    for (let i = 0; i < 50; i++) {
      const nextDate = new Date(today.getTime() + i * 24 * 60 * 60 * 1000);
      this.dates.push(formatDate(nextDate, 'yyyy-MM-dd', 'en-US'));
    }
  }

  // 初始化選中狀態
  initializeGrid() {
    this.selectedCells = this.dates.map(() => this.hours.map(() => false));
    this.showCells = this.dates.map(() => this.hours.map(() => false));
    this.backUpPreSelectedCells = this.dates.map(() =>
      this.hours.map(() => false)
    );
    this.tempSaveBeans = [];
    this.saveBeans = [];
  }

  search(isCancel: boolean) {
    this.isSearchFormOpen = false;
    this.isQuerySuccessful = false;

    this.isLoading = true;
    if (this.searchForm.invalid) {
      this.submitted = true;
      this.toastService.warn(
        this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired')
      );
      this.isSearchFormOpen = true;
      this.isLoading = false;
      return;
    }
    if (isCancel) {
      this.cancelEdit(false);
    }
    this.initializeGrid();

    this.scheduleEffectiveTimeSettingService
      .searchScheduleEffectiveTimeSetting(this.searchRequest)
      .subscribe({
        next: (result) => {
          this.searchResult = result.dataList ?? [];
          this.headerSeqNo = result.headerSeqNo;
          this.isQuerySuccessful = true;
          this.highlightSearchResult();
          this.startTimeArray = this.dates.map((date) => {
            // 找到該日期的所有時間段
            const foundTimes = this.searchResult
              .filter(
                (setting) =>
                  formatDate(setting.effectiveDate, 'yyyy-MM-dd', 'en-US') ===
                  date
              )
              .map((setting) => setting.startTime); // 取得所有 startTime 陣列
            return foundTimes.length > 0 ? foundTimes : [[null, null]]; // 預設為 [[null, null]]
          });

          this.endTimeArray = this.dates.map((date) => {
            // 找到該日期的所有時間段
            const foundTimes = this.searchResult
              .filter(
                (setting) =>
                  formatDate(setting.effectiveDate, 'yyyy-MM-dd', 'en-US') ===
                  date
              )
              .map((setting) => setting.endTime); // 取得所有 endTime 陣列
            return foundTimes.length > 0 ? foundTimes : [[null, null]]; // 預設為 [[null, null]]
          });
          this.isLoading = false;
        },
        error: (error: any) => {
          this.isQuerySuccessful = false;
          this.toastErrorMessage(error.error);
          this.isLoading = false;
        },
      });
  }

  highlightSearchResult() {
    if (isNullOrEmpty(this.searchResult) || this.searchResult.length == 0) {
      return;
    }
    this.searchResult.forEach((setting) => {
      // 將時間戳轉換為 Date 對象
      const effectiveDate = new Date(setting.effectiveDate);

      // 格式化日期，方便與 this.dates 匹配
      const formattedDate = formatDate(effectiveDate, 'yyyy-MM-dd', 'en-US');

      // 將 startTime 和 endTime 陣列轉換為物件
      const startTime = {
        hour: setting.startTime[0],
        minute: setting.startTime[1],
      };
      const endTime = { hour: setting.endTime[0], minute: setting.endTime[1] };

      // 找到日期對應的索引
      const dateIndex = this.dates.findIndex((date) => date === formattedDate);

      if (dateIndex !== -1) {
        // 根據小時範圍進行高亮處理
        for (let i = startTime.hour; i <= endTime.hour; i++) {
          this.showCells[dateIndex][i] = true;
          this.backUpPreSelectedCells[dateIndex][i] = true;
        }
      }
    });
  }

  resetSearch() {
    this.searchForm.reset();
    this.searchRequest = {};
  }

  enableEdit() {
    this.isEditable = true;
  }

  cancelEdit(isSearch: boolean) {
    this.isEditable = false;
    if (isSearch) {
      this.search(false);
      this.saveBeans = [];
      this.tempSaveBeans = [];
    }
  }

  onMouseDown(row: number, col: number, event: MouseEvent) {
    this.isMouseDown = true;
    this.startRow = row;
    this.startCol = col;
    this.endRow = row;
    this.endCol = col;
    this.selectedCellsState.clear(); // 清空當次拖曳記錄
    this.updateSelection();
  }

  toggleCells(row: number, col: number) {
    this.showCells[row][col] = !this.showCells[row][col];
    this.selectedCells[row][col] = !this.selectedCells[row][col];
  }

  onMouseEnter(row: number, col: number) {
    if (this.isMouseDown) {
      this.endRow = row;
      this.endCol = col;
      this.updateSelection();
    }
  }

  updateSelection() {
    const minRow = Math.min(this.startRow, this.endRow);
    const maxRow = Math.max(this.startRow, this.endRow);
    const minCol = Math.min(this.startCol, this.endCol);
    const maxCol = Math.max(this.startCol, this.endCol);

    const newSelectedCells = new Map<string, boolean>();

    // 找出當前範圍內的所有格子
    for (let i = minRow; i <= maxRow; i++) {
      for (let j = minCol; j <= maxCol; j++) {
        const cellKey = `${i},${j}`;
        newSelectedCells.set(cellKey, !this.showCells[i][j]); // 取反狀態
      }
    }

    // 處理選取(滑過)的格子（newSelectedCells中但不在 `selectedCellsState` 中）
    for (const [cellKey, newState] of newSelectedCells) {
      if (!this.selectedCellsState.has(cellKey)) {
        const [i, j] = cellKey.split(',').map(Number);
        this.showCells[i][j] = newState;
        this.selectedCells[i][j] = newState;
      }
    }

    // 處理取消選取(往回滑)的格子（`selectedCellsState` 中但不在 `newSelectedCells`）
    for (const cellKey of this.selectedCellsState.keys()) {
      if (!newSelectedCells.has(cellKey)) {
        const [i, j] = cellKey.split(',').map(Number);
        this.showCells[i][j] = !this.showCells[i][j]; // 反轉回去
        this.selectedCells[i][j] = !this.selectedCells[i][j];
      }
    }

    // 更新本次選取狀態
    this.selectedCellsState = newSelectedCells;
  }

  onMouseUp(row: number, col: number, event: MouseEvent) {
    this.isMouseDown = false;
    this.isDialogOpen = true;
    this.endRow = row;
    this.endCol = col;
    this.dialogData = { startMinute: 0, endMinute: 0 };
  }

  clearSelection() {
    this.selectedCells.forEach((row) => row.fill(false));
  }

  confirm(startMinute: number, endMinute: number) {
    this.tempSaveBeans = [];
    for (let row = 0; row < this.dates.length; row++) {
      let startHour: number | null = null;
      let endHour: number | null = null;
      let isSave: boolean = false;
      for (let col = 0; col <= this.hours.length; col++) {
        if (this.selectedCells[row][col]) {
          if (startHour === null) {
            startHour = col;
            endHour = col;
          } else {
            endHour = col;
          }
        } else if (startHour !== null) {
          if (startHour == endHour && endMinute - startMinute < 10) {
            this.toastService.error(
              this.translateService.instant(
                'ScheduleSetting.Messege.EndMinuteLessThanStartError'
              )
            );
            this.showCells = this.backUpPreSelectedCells.map((row) => [...row]);
            this.clearSelection();
            return;
          }
          if (!isSave) {
            this.createThisSelectCells(
              this.startCol,
              this.endCol!,
              startMinute,
              endMinute,
              row
            );
            isSave = true;
          }
          startHour = null;
          endHour = null;
        } else if (this.startRow == row && this.startCol == col) {
          if (!isSave) {
            this.createThisSelectCells(
              this.startCol,
              this.endCol!,
              startMinute,
              endMinute,
              row
            );
            isSave = true;
          }
        }
      }
    }
    const uniqueTempSaveBeans = Array.from(
      new Set(this.tempSaveBeans.map((bean) => JSON.stringify(bean)))
    ).map((item) => JSON.parse(item));

    this.saveBeans.push(...uniqueTempSaveBeans);
  }

  createThisSelectCells(
    startHour: number,
    endHour: number,
    startMinute: number,
    endMinute: number,
    row: number
  ) {

      this.tempSaveBeans.push(
        this.createSaveBean(row, startHour, endHour, startMinute, endMinute)
      );

  }

  createSaveBean(
    row: number,
    startHour: number,
    endHour: number,
    startMinute: number,
    endMinute: number
  ): SaveScheduleEffectiveTimeSettingBean {
    let validStartHour = startHour;
    let validEndHour = endHour;
    if (startHour > endHour) {
      validStartHour = endHour;
      validEndHour = startHour;
    }
    return {
      startHour: this.padZero(validStartHour),
      endHour: this.padZero(validEndHour),
      headerSeqNo: this.headerSeqNo,
      plant: this.searchRequest.plant,
      effectiveDate: new Date(this.dates[row]),
      startMin: this.padZero(startMinute),
      endMin: this.padZero(endMinute),
    };
  }


  private padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  closeDialog(save: boolean) {
    if (save) {
      this.validateMinutes();
      this.confirm(this.dialogData.startMinute, this.dialogData.endMinute);
      this.backUpPreSelectedCells = this.showCells.map((row) => [...row]);
      this.isDialogOpen = false;
      this.clearSelection();
    } else {
      this.isDialogOpen = false;
      this.showCells = this.backUpPreSelectedCells.map((row) => [...row]);
      this.clearSelection();
    }
  }

  save() {
    this.isLoading = true;
    const saveRequest: SaveScheduleEffectiveTimeSettingRequest = {
      saveScheduleEffectiveTimeSettingBean: this.saveBeans,
    };
    this.scheduleEffectiveTimeSettingService
      .saveScheduleEffectiveTimeSetting(saveRequest)
      .subscribe({
        next: () => {
          this.tempSaveBeans = [];
          this.saveBeans = [];
          this.search(true);
        },
        error: (error: any) => {
          this.toastService.error(error);
          this.isLoading = false;
        },
      });
  }

  getTime(row: number): string {
    const startTimes = this.startTimeArray[row];
    const endTimes = this.endTimeArray[row];

    if (
      !startTimes ||
      !endTimes ||
      startTimes.length === 0 ||
      endTimes.length === 0
    )
      return '';

    return startTimes
      .map((startTime, index) => {
        const endTime = endTimes[index];
        if (
          !startTime ||
          startTime[0] === null ||
          startTime[1] === null ||
          !endTime ||
          endTime[0] === null ||
          endTime[1] === null
        ) {
          return '';
        }
        return (
          `${startTime[0].toString().padStart(2, '0')}:${startTime[1]
            .toString()
            .padStart(2, '0')} - ` +
          `${endTime[0].toString().padStart(2, '0')}:${endTime[1]
            .toString()
            .padStart(2, '0')}`
        );
      })
      .filter((timeString) => timeString !== '')
      .join('\n');
  }

  validateMinutes(): boolean {
    return (
      this.dialogData.startMinute >= 0 &&
      this.dialogData.startMinute <= 59 &&
      this.dialogData.endMinute >= 0 &&
      this.dialogData.endMinute <= 59 &&
      Number.isInteger(this.dialogData.startMinute) &&
      Number.isInteger(this.dialogData.endMinute)
    );
  }

  deleteBtnClick(row: number) {
    this.isLoading = true;
    const deleteRequest: DeleteScheduleEffectiveTimeSettingRequest = {
      headerSeqNo: this.headerSeqNo,
      effectiveDate: new Date(this.dates[row]),
    };
    this.scheduleEffectiveTimeSettingService
      .deleteScheduleEffectiveTimeSetting(deleteRequest)
      .subscribe(() => {
        this.showCells[row] = this.showCells[row].map(() => false);
        this.saveBeans = this.saveBeans.filter(
          (x) => x.effectiveDate !== new Date(this.dates[row])
        );
        this.backUpPreSelectedCells[row] = this.backUpPreSelectedCells[row].map(
          () => false
        );
        this.startTimeArray[row] = [];
        this.endTimeArray[row] = [];
        this.isLoading = false;
      });
  }
  openUrgentNoSetting() {
    this.showUrgentNoSetting = true;
    // 刪掉舊的 toast, 避免訊息顯示在舊的zIndex層
    this.toastService.clear();
  }
  onUrgentSettingScheduleChange(event: DropdownChangeEvent) {
    this.searchUrgentList();
  }
  searchUrgentList() {
    this.isUrgentSettingLoading = true;
    this.scheduleEffectiveTimeSettingService.searchUrgentList(this.urgentSettingScheduleName)
    .pipe(finalize(() => {
      this.isUrgentSettingLoading = false;
      this.clearAddUrgentNo();
    }))
    .subscribe({
      next: (resp) => {
        this.urgentNoDatas = resp.urgentList.map((urgentNo: any) => ({
          urgentNo: urgentNo,
        }));
      },
      error: (resp) => {
        if (resp.error) {
          this.toastErrorMessage(resp.error);
        }
      },
    });
  }
 
  deleteUrgentNo(rowData: any) {
    this.isUrgentSettingLoading = true;
    this.scheduleEffectiveTimeSettingService.deleteUrgentList({ scheduleName: this.urgentSettingScheduleName, urgentNo: rowData.urgentNo })
    .pipe(finalize(() => {
      this.isUrgentSettingLoading = false;
    }))
    .subscribe({
      next: () => {
        this.searchUrgentList();
        this.toastService.success(this.translateService.instant('Common.Message.SuccessDelete'));
      },
      error: (resp) => {
        if (resp.error) {
          this.toastErrorMessage(resp.error);
        }
      },
    });
  }
  addUrgentNo() {
    this.isAddingUrgentNo = true;
  }
  confirmAddUrgentNo() {
    // validate
    if (isEmpty(this.newUrgentNo)) {
      this.toastService.warn(this.translateService.instant('ScheduleSetting.UrgentNoSetting.Validation.EmptyUrgentNoError'));
      return;
    } else if (isEmpty(this.urgentSettingScheduleName)) {
      this.toastService.warn(this.translateService.instant('ScheduleSetting.UrgentNoSetting.Validation.EmptyScheduleNameError'));
      return;
    }
    // send request
    this.isUrgentSettingLoading = true;
    this.scheduleEffectiveTimeSettingService.insertUrgentList({ scheduleName: this.urgentSettingScheduleName, urgentNo: this.newUrgentNo })
    .pipe(finalize(() => {
      this.isUrgentSettingLoading = false;
      this.clearAddUrgentNo();
    }))
    .subscribe({
      next: () => {
        this.searchUrgentList();
        this.toastService.success(this.translateService.instant('Common.Message.SuccessSave'));
      },
      error: (resp) => {
        if (resp.error) {
          this.toastErrorMessage(resp.error);
        }
      },
    });
  }
  
  clearAddUrgentNo() {
    this.newUrgentNo = '';
    this.isAddingUrgentNo = false;
  }

  onUrgentNoSettingHide() {
    this.clearAddUrgentNo();
    this.urgentSettingScheduleName = '';
    this.urgentNoDatas = [];
  }
}
